import isVAT, {VATCountryCode} from "validator/lib/isVAT";

const POLISH_TAX_ID_NO_WEIGHTS = [6, 5, 7, 2, 3, 4, 5, 6, 7];

export const isValidPolishTaxIdNo = (taxIdNo: string) => {
    if (!/^\d{10}$/.test(taxIdNo)) return false;

    const checksum = POLISH_TAX_ID_NO_WEIGHTS.reduce((sum, weight, index) => sum + weight * Number(taxIdNo[index]), 0) % 11;

    return checksum !== 10 && checksum === Number(taxIdNo[9]);
}

export const normalizeTaxIdNo = (value: string) => value.replace(/[\s\-.]/g, "").toUpperCase();

export const isValidTaxIdNo = (value?: string) => {
    if (!value) return true;

    const taxIdNo = normalizeTaxIdNo(value);

    if (/^\d+$/.test(taxIdNo)) return isValidPolishTaxIdNo(taxIdNo);
    if (taxIdNo.startsWith("PL")) return isValidPolishTaxIdNo(taxIdNo.slice(2));

    try {
        return isVAT(taxIdNo, taxIdNo.slice(0, 2) as VATCountryCode);
    } catch (e) {
        return false;
    }
}
